import { render, staticRenderFns } from "./Bucketlist.vue?vue&type=template&id=0e986b8e&"
import script from "./Bucketlist.vue?vue&type=script&lang=js&"
export * from "./Bucketlist.vue?vue&type=script&lang=js&"
import style0 from "./Bucketlist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports